'use strict';
import {combineReducers} from 'redux';
import {formResponseRequirementExports} from '../redux/formResponseRequirementExports';
import {reduxList as formsReduxList} from '../redux/forms';
import {FORM_EXPORT_REQ_NAME, FORM_LIST_NAME, UPDATE_SINGLE_FORM_RESPONSE_NAME} from '../redux/state';
import {updateSingleResponseReduxRequest} from '../redux/updateSingleResponse';


export * from './state';

export const forms = combineReducers({
  [FORM_EXPORT_REQ_NAME]: formResponseRequirementExports.reducers.reducer,
  [FORM_LIST_NAME]: formsReduxList.reducers.reducer,
  [UPDATE_SINGLE_FORM_RESPONSE_NAME]: updateSingleResponseReduxRequest.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/forms/reducers/index.js